/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import { motion } from 'framer-motion';
import React,{useCallback,useState,useContext} from 'react'
import { Link } from 'react-router-dom';
import { CDN } from '../../constants';
import CategoryToolTip from '../CategoryToolTip';
import { ExpectedDateGenerator } from '../../redux/helper/DateConverter';
import OfferToolTip from '../OfferToolTip';
import HeaderContext from '../Context/HeaderContext';
import { CartPayload } from '../../redux/helper/CartPayloadGenerator';
import { distributorService } from '../../service/distributor.service';
import WishlistHandler from '../WishlistHandler';
import { Addtowishlist, WishlistExist } from '../../redux/helper/AddWishlist';
import ReactModal from 'react-modal';
import RemovePopup from '../../Pages/CartManagement/RemoveItem.jsx';
import './style.css';
import { DebounceInput } from 'react-debounce-input';

export default function OfferProductCard({idx,
    specialCartList,
    cartCountObj,
    prod,
    GetCartItems,
    wishProducts,
    setcartCount}) {
    // let  cartCount=CriteriaObj[prodItem[selectedCriteria].id].cartCount
    const handleImage = (img)=> img?`${CDN}/product-images/${img}`:'/images/gen.png';
    const [hoverId, sethoverId] = useState('');
    const [OfferhoverId, setOfferhoverId] = useState('');
    const [removePopup, setremovePopup] = useState('')
    const profile = JSON.parse(localStorage.getItem('user'))?.profile
    const [removeLoader, setremoveLoader] = useState(false)
    const [loading, setloading] = useState(false);
    const [ModalOpen, setModalOpen] = useState('');
    const [loader, setloader] = useState(false);
    const [productLoad, setproductLoad] = useState(false)
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup
    } = useContext(HeaderContext);
    
    function nearest(n, x) {
        let u = n % x >= x / 2;
        return n + (-1) ** (1 - u) * Math.abs(x * u - n % x);
    }
    
    const handleProductCount=(product)=>{
        let count=(product?.MINIMUM_ORDER_QUANTITY ||1) < (product?.PACKING_SIZE || 1)? (product?.PACKING_SIZE ||1) : (product?.MINIMUM_ORDER_QUANTITY ||1);
        return count;
    }
    const handleQuantityChange = (type,quantity,product)=>{
        let copy=Number(cartCountObj[product.CONCATENATED_SEGMENTS]||0)
        if(type==='+'){
            copy =  nearest(copy, (Number(product?.PACKING_SIZE)||1))
            if(copy < Number(handleProductCount(product))){
                copy= handleProductCount(product)
                setcartCount(product.CONCATENATED_SEGMENTS,copy,product,'action')
                return     
            }
            copy += Number(product.PACKING_SIZE) || 1;
        }
        if(type==='-'){
            if (copy - product.PACKING_SIZE >= product?.MINIMUM_ORDER_QUANTITY) {
                if (Math.round(parseFloat(copy) * 10000) % Math.round(parseFloat(product.PACKING_SIZE ||1) * 10000) !==0) {
                    copy = nearest(copy, (Number(product?.PACKING_SIZE) || 1));
                } else copy -= Number(product?.PACKING_SIZE) || 1;
            }else{
                copy = 0
            }
        }
        copy = Number(copy).toFixed(2)
        setcartCount(product.CONCATENATED_SEGMENTS,copy,product,'action')
    }
    
    const handleErrorMessage = (message,key)=>{
        SetErrorMessage(message ||'Something went wrong');
        setcolorValue(true);
        GetCartItems();
        setModalOpen('');
        setproductLoad(false)
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);
            setloading(false);
            setremoveLoader(false)
            setremovePopup('')

        }, 3000);
    }
    const handleSuccessMessage = (message,key)=>{
        SetSuccessMessage(message);
        setModalOpen('');
        GetCartItems();
        setproductLoad(false)
        setTimeout(() => {
            SetSuccessMessage('');
            setcolorValue(false);
            setloading(false);
            setremoveLoader(false)
            setremovePopup('')
            if(key==='diff'){
                setModalOpen('popup');
            }
        },3000)
    }
    const handleAddToWishList = (selected,related)=>{
        setloader(true)
        setproductLoad(true)
        Addtowishlist(prod,selected).then((res)=>{
            if(res.data.success_status){
                handleSuccessMessage(res.data.message,'wish')
            }else{
                handleErrorMessage(res.message.response.data.message,'wish')
            }
            setloader(false)
            
        })
    }
    const handleError = ()=>{
        let status=false;
        if(parseFloat(cartCountObj[prod.CONCATENATED_SEGMENTS]) < parseFloat(prod.MINIMUM_ORDER_QUANTITY)){
            status=true
        }
        if(Math.round(parseFloat(cartCountObj[prod.CONCATENATED_SEGMENTS]) * 10000) % Math.round(parseFloat(prod.PACKING_SIZE ||1) * 10000) !==0){
            status=true
        }
        return status
    }

    return (
        !productLoad && (
            <div className={`rounded-lg bg-[#FFFFFF] shadow-s7 px-4 pb-1.5 pt-4 relative ${idx===0?'':'mt-5'}`}>
                <div className="flex flex-wrap">
                    <div className="xl:w-[75%] w-full pt-2">
                        <div className="flex">
                            <div className="w-1/4">
                                <Link to={`/products/${prod.INVENTORY_ITEM_ID}/view`}>
                                    <motion.img initial={{ opacity: 0, scale: 0.6 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{
                                            duration: 0.8,
                                            delay: 0.5,
                                            ease: [0, 0.71, 0.2, 1.01]
                                        }} src={handleImage(prod?.IMAGE_NAME)} alt="icon" className="w-full" />
                                </Link>                        </div>
                            <div className="pl-2.5">
                                <div>
                                    <Link to={`/products/${prod.INVENTORY_ITEM_ID}/view`}><p className="sm:text-xl text-base font-bold text-[#090406] pr-3">{prod?.MODEL_DESCRIPTION || `${prod?.DESCRIPTION.length > 20 ? `${prod.DESCRIPTION.slice(0,20)}...`:`${prod.DESCRIPTION}`}`}<span className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit ml-2.5">{prod?.MAIN_CATEGORY}</span></p></Link>
                                </div>
                                <p className="sm:text-xs6 text-xs2 font-normal text-[#808285] mt-1"><span>Product Code: {prod?.CONCATENATED_SEGMENTS}</span><span className="sm:px-4 px-2">|</span><span>AWS Classification: {prod?.AWS_CLASSIFICATION}</span></p>
                                <div className="mt-2 flex sm:items-center items-baseline sm:flex-row flex-col">
                                    <div className="flex sm:border-r sm:border-[#707070] sm:pr-[6px] w-fit items-center">
                                        <p className="text-xs font-semibold text-[090406]">Category</p>
                                        <p className="text-xs3 font-semibold text-white px-1 bg-[#555259] rounded-[3px] w-fit mx-1.5">{prod?.DELIVERY_LEAD_TIME}</p>
                                        <button  >
                                            <img src="/images/info_icon.svg" alt="icon" className="cursor-pointer w-[10px]" onMouseEnter={()=>{
                                                setTimeout(() => {
                                                    sethoverId(prod.INVENTORY_ITEM_ID)
                                                }, 1000);
                                            }} onMouseLeave={()=>{
                                                setTimeout(() => {
                                                    sethoverId('')
                                                }, 2000);
                                            }}/>
                                        </button>
                                        {hoverId=== prod.INVENTORY_ITEM_ID &&(
                                            <CategoryToolTip hover={hoverId=== prod.INVENTORY_ITEM_ID}/>
                                        )}
                                    </div>
                                    <p className="text-xs font-semibold text-[#808285] sm:px-[6px] sm:border-r sm:border-[#707070] sm:pt-0 pt-1">Expected Dispatch: <span className="font-bold text-[#555259]">{prod.DELIVERY_LEAD_TIME ? ExpectedDateGenerator(prod?.DELIVERY_LEAD_TIME):'-'}</span></p>
                                    <p className="text-xs font-semibold text-[#808285] sm:pl-[6px] sm:pt-0 pt-1">Method of Packing: <span className="font-bold text-[#555259]">{prod?.METHOD_OF_PACKING}</span></p>
                                </div>
                            </div>
                        </div>
                        <div className="lg:w-[70%] w-full sm:pl-4">
                            <p className="sm:text-base text-xs6 font-normal text-[#808285] sm:pt-1 pt-2">{prod?.DESCRIPTION}</p>
                        </div>
                    </div>
                    <div className="xl:w-[25%] w-full pt-0 xl:mt-0 mt-3">
                        <div className="flex justify-end w-full xl:pr-[72px] pr-0">
                            <p className={`sm:text-xs6 text-xs2 font-normal text-[#808285] bg-[#F5F5FA] rounded-[3px] px-2.5 py-[7px] w-fit  xl:mb-0 mb-3 ${profile?.PRIVILAGES.includes('stock_visibility')?'':'opacity-0'}`}>Stock: {prod?.STOCK_VISIBILITY ? <span className="text-[#424446] font-semibold">{prod?.STOCK_ONHAND_QTY} <>{prod?.PRIMARY_UOM_CODE}</></span>:0}</p>
                        </div>
                    </div>
                </div>
                <div className= {'lg:w-[80%] w-full lg:px-4 pt-2.5 pb-3.5'}>
                    <div className="flex sm:flex-row flex-col">
                        <div className="flex items-center sm:w-[50%] w-full">
                            <div className="w-[50%]">
                                <p className="text-xs font-semibold text-[#808285]">Unit of Measurement</p>
                                <p className="text-xs6 font-semibold text-[#555259]">{prod?.PRIMARY_UOM_CODE}</p>
                            </div>
                            <div className="w-1/2">
                                <p className="text-xs font-semibold text-[#808285]">Minimum Order Quantity</p>
                                <p className="text-xs6 font-semibold text-[#555259]">{prod?.MINIMUM_ORDER_QUANTITY || 1}<>{prod?.PRIMARY_UOM_CODE}</></p>
                            </div>
                        </div>
                        <div className="flex items-center sm:w-[50%] w-full sm:mt-0 mt-3">
                            <div className="w-1/2">
                                <p className="text-xs font-semibold text-[#808285]">Standard Pack Size</p>
                                <p className="text-xs6 font-semibold text-[#555259]">{prod?.PACKING_SIZE||1} {prod?.PRIMARY_UOM_CODE}</p>
                            </div>
                            <div className="w-1/2">
                                <p className="text-xs font-semibold text-[#808285]">Size</p>
                                <p className="text-xs6 font-semibold text-[#555259]">
                                    <>
                                        <>{`${prod.DIAMETER!==null ?`${prod.DIAMETER}mm`:''}`}</>
                                        <>{`${prod.LENGTH!==null && prod.DIAMETER ? 'x':''}`}</>
                                        <>{`${prod.LENGTH!==null ?`${prod.LENGTH}mm`:''}`}</>
                                        <>{prod.LENGTH===null && prod.DIAMETER===null ? '-':''}</>
                                    </>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pt-2 border-t border-[#CBCBCB] w-full flex items-center xl:flex-row flex-col lg:px-4 px-0">
                    <div className="flex items-center xl:justify-start xl:w-[50%] w-full justify-between">
                        <div className="xl:w-[65%] w-full">
                            <p className="text-xs3 font-semibold text-[#808285]">List Price</p>
                            <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#15090E]">
                                {Number(prod?.LIST_PRICE)?.toLocaleString('en-IN', {
                                    style: 'currency',
                                    currency: 'INR',
                                })}</p>
                        </div>
                        <div className="sm:ml-[30px] ml-4">
                            <p className="text-xs3 font-semibold text-[#808285] text-center mr-[17px] ">Set Quantity</p>
                            <div className="flex justify-center pt-2">
                                <button
                                    onClick={()=>handleQuantityChange('-',cartCountObj[prod.CONCATENATED_SEGMENTS],prod)}
                                    type="button" className="min-w-[42px] min-h-[22px]">
                                    <img src="/images/Group8502.png" alt="icon" className="cursor-pointer sm:mr-4" style={{minHeight:'20px'}}/>
                                </button>
                                <DebounceInput
                                    minLength={1}
                                    onScroll={(e)=>e.preventDefault()}
                                    onWheel={e => e.target.blur()}
                                    debounceTimeout={300}
                                    type="number"
                                    onKeyDown={(e) => ['ArrowUp','ArrowDown'].includes(e.key) && e.preventDefault()}
                                    value={cartCountObj[prod.CONCATENATED_SEGMENTS] || 0}
                                    className="w-[100px] h-[18px] rounded border border-[#808285] outline-0 text-center px-1 sm:text-xs17 text-xs13 font-semibold text-[#090406] mx-2 mt-1" 
                                    onKeyUp={(e)=>{
                                        let val = e.target.value === ''?0:parseInt(e.target.value, 10);
                                        setcartCount(prod.CONCATENATED_SEGMENTS,val,prod) 
                                    }}
                                                
                                />
                                <p className="text-xs3 font-semibold text-[#808285] self-center mt-1 sm:mr-4 mr-2">{prod?.PRIMARY_UOM_CODE}</p>
                                <button
                                    onClick={()=>handleQuantityChange('+',cartCountObj[prod.CONCATENATED_SEGMENTS],prod)}
                                    type="button" className="min-w-[42px] min-h-[22px]">
                                    <img src="/images/Group8503.png" alt="icon" className="cursor-pointer" style={{minHeight:'20px'}}/>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center justify-between xl:w-[50%] w-full xl:mt-0 mt-4">
                        <div className="xl:ml-10 invisible">
                            <p className="text-xs3 font-semibold text-[#808285]">Discount</p>
                            <p className="text-lg font-semibold text-[#15090E] flex items-center pt-0.5">{prod?.discount_applied||0}<>{prod?.discount_type===""||null?'':'%'}</>
                                <span className="ml-1">
                                    <button data-tooltip-target="tooltip-discountPercentage" data-tooltip-placement="right" data-tooltip-trigger="click" type="button">
                                        <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer" onMouseEnter={()=>{
                                            setTimeout(() => {
                                                setOfferhoverId(prod.INVENTORY_ITEM_ID)
                                            }, 100);
                                        }} onMouseLeave={()=>{
                                            setTimeout(() => {
                                                setOfferhoverId('')
                                            }, 500);
                                        }}/>
                                    </button>
                                    {OfferhoverId=== prod.INVENTORY_ITEM_ID &&(
                                        <OfferToolTip hover={OfferhoverId=== prod.INVENTORY_ITEM_ID} prod={prod}/>
                                    )}
                                    <OfferToolTip prod={prod} />
                                </span>
                            </p>
                        </div>
                        <div className="md:min-w-[284px] w-[150px] bg-[#F5F5FA] rounded-lg text-center py-1.5">
                            <p className="text-xs2 font-semibold text-[#808285]">Total Price</p>
                            <p className="md:text-xs4 text-base font-semibold text-[#15090E] sm:pt-0.5">
                                {Number(specialCartList[prod.INVENTORY_ITEM_ID]?.sub_total||0)?.toLocaleString('en-IN', {
                                    style: 'currency',
                                    currency: 'INR',
                                })}</p>
                        </div>
                    </div>
                </div>
                {ModalOpen !=='' && <WishlistHandler 
                    setmodalType={setModalOpen}
                    selectedItem={prod}
                    handleAddToWishList={handleAddToWishList}
                    wishlistLoader={loader}
                    wishlistProduct={wishProducts}
                    handleErrorMessage={handleErrorMessage}
                    handleSuccessMessage={handleSuccessMessage}
                    FromCart={true}
                />}
                <div >
                    <p className={`lg:px-4 mt-2 text-xs3 font-normal ${ handleError()?'text-[red]':'text-[#808285]'} flex items-center`}>
                        <span className="mr-1">
                            <img src="/images/info_icon1.svg" alt="icon" className="min-w-[9px] min-h-[9px]"/>
                        </span>
                        Quantity is based on the MOQ and Standard Pack Size 
                    </p>
                    <button type="button" data-bs-toggle="modal" data-bs-target="#exampleModalCenter2">
                        <img src={ WishlistExist(wishProducts,prod.INVENTORY_ITEM_ID)?'/images/heart_active.svg':'/images/Iconawesome-heart.svg'} alt="" 
                            onClick={()=>{
                                setModalOpen('popup');
                            }} className="absolute sm:top-6 top-[17px] sm:right-[60px] right-[50px] cursor-pointer"/>
                    </button>
                </div>

            </div>
        )
    )
}
